require 'angular'

angular.module('workflow.app')

.directive 'slider', () ->
  return {
    scope:{
      labels: "=",
      max: "=",
      model: "="
      onChange: "="
    },
    link: (scope, ele, attrs) ->
      ele.slider
        min: 0,
        max: scope.max,
        value: scope.model
      .slider("pips", {
        rest: 'label',
        # FIXME: Hack to make work for risk/relevancy
        #        This makes this pretty unusable for anything else, and
        #        also relies on max being set to 9.
        labels: ['All', '', '', '', '', '', '', '', '', 'Most material']
      })
      .on "slidechange", (e, ui) ->
        scope.onChange(ui.value)
  }
